import axios from 'axios'
import { COMPANY_SLUG } from '@/config/companyProfile'

const rawBaseUrl = import.meta.env.VITE_API_URL || '/api/v1'
const baseURL = rawBaseUrl.endsWith('/') ? rawBaseUrl.slice(0, -1) : rawBaseUrl

const api = axios.create({ baseURL })

const TOKEN_KEY = `${COMPANY_SLUG}_token`
const REFRESH_TOKEN_KEY = `${COMPANY_SLUG}_refresh_token`

api.interceptors.request.use(config => {
  const token = localStorage.getItem(TOKEN_KEY)
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

let refreshPromise = null

api.interceptors.response.use(
  response => response,
  async error => {
    const originalRequest = error?.config
    const status = error?.response?.status

    if (!originalRequest || status !== 401) {
      return Promise.reject(error)
    }

    if (originalRequest.url?.includes('/auth/login') || originalRequest.url?.includes('/auth/register') || originalRequest.url?.includes('/auth/refresh')) {
      return Promise.reject(error)
    }

    if (originalRequest.__isRetryRequest) {
      return Promise.reject(error)
    }

    const refreshToken = localStorage.getItem(REFRESH_TOKEN_KEY)
    if (!refreshToken) {
      return Promise.reject(error)
    }

    if (!refreshPromise) {
      refreshPromise = api.post('/auth/refresh', { refreshToken })
        .then(res => {
          const data = res.data
          if (data?.accessToken) localStorage.setItem(TOKEN_KEY, data.accessToken)
          if (data?.refreshToken) localStorage.setItem(REFRESH_TOKEN_KEY, data.refreshToken)
          return data
        })
        .finally(() => {
          refreshPromise = null
        })
    }

    try {
      await refreshPromise
      originalRequest.__isRetryRequest = true
      return api(originalRequest)
    } catch (refreshError) {
      localStorage.removeItem(TOKEN_KEY)
      localStorage.removeItem(REFRESH_TOKEN_KEY)
      return Promise.reject(refreshError)
    }
  }
)

export default api
